module.exports = __webpack_public_path__ + "img/dcm-logo-dark-text.f347327e.png";